import {
  FETCHING_EXHIBITION_TIMESLOTS_REQUEST,
  FETCHING_EXHIBITION_TIMESLOTS_SUCCESS,
  FETCHING_EXHIBITION_TIMESLOTS_FAILURE,
} from "../actions/types";
import ResponseService from "../../utils/ResponseService";
import ApplicationError from "../../utils/ApplicationError";

const initialState = {
  timeslots: [],
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData(),
};

const timeslotsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_EXHIBITION_TIMESLOTS_REQUEST:
      return { ...state, isFetching: true };
    case FETCHING_EXHIBITION_TIMESLOTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        timeslots: action.payload.objects,
        error: ApplicationError.buildDefault(),
      };

    case FETCHING_EXHIBITION_TIMESLOTS_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    default:
      return state;
  }
};

export default timeslotsReducer;
